/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_Drag_Drop_SubtitleInputs */

const en_nav_app_drag_drop_subtitle = /** @type {(inputs: Nav_App_Drag_Drop_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`files here`)
};

const es_nav_app_drag_drop_subtitle = /** @type {(inputs: Nav_App_Drag_Drop_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`archivos aquí`)
};

/**
* | output |
* | --- |
* | "files here" |
*
* @param {Nav_App_Drag_Drop_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_drag_drop_subtitle = /** @type {((inputs?: Nav_App_Drag_Drop_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_Drag_Drop_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_drag_drop_subtitle(inputs)
	return en_nav_app_drag_drop_subtitle(inputs)
});